import gsap from "gsap";
import Swiper, { Autoplay, Navigation, Pagination } from "swiper";

export default function topNewsSlider() {
  if (
    document.querySelectorAll(
      ".is-top .section-news .news-list-sp .swiper .swiper-slide"
    ).length < 2
  ) {
    gsap.set(
      ".is-top .section-news .news-list-sp .swiper .swiper-button-next, .is-top .section-news .news-list-sp .swiper .swiper-button-prev",
      {
        display: "none",
      }
    );

    return;
  }

  new Swiper(".is-top .section-news .news-list-sp .swiper", {
    modules: [Navigation, Pagination, Autoplay],

    autoplay: {
      delay: 5000,
    },

    loop: true,

    loopAdditionalSlides: 2,

    // If we need pagination
    pagination: {
      el: ".is-top .section-news .news-list-sp .swiper .swiper-pagination",
      clickable: true,
    },

    // Navigation arrows
    navigation: {
      nextEl: ".is-top .section-news .news-list-sp .swiper-button-next",
      prevEl: ".is-top .section-news .news-list-sp .swiper-button-prev",
    },

    spaceBetween: 25,
  });
}
